import { TFunction } from 'i18next';
import { FreshnessState } from '../../services/pantryFreshnessService';

export function freshnessDaysLabel(t: TFunction, days: number | null, state: FreshnessState): string {
  if (state === 'stable') return t('pantry.freshness.stable');
  if (state === 'review') {
    if (days != null && days < 0) {
      return days === -1 ? t('pantry.freshness.expiredYesterday') : t('pantry.freshness.expiredDays', { count: -days });
    }
    return t('pantry.freshness.review');
  }
  if (days == null) return '';
  // A freezer row always reads "fresh" whatever its date says, so a stale date
  // inherited from the fridge used to print through as "~-2 days" in a green
  // pill. Nothing below this line can express a date in the past; say nothing
  // rather than something absurd.
  if (days < 0) return '';
  if (days === 0) return t('pantry.freshness.today');
  if (days === 1) return t('pantry.freshness.tomorrow');
  if (days <= 6) return t('pantry.freshness.days', { count: days });
  if (days <= 13) return t('pantry.freshness.oneWeek');
  if (days <= 20) return t('pantry.freshness.twoWeeks');
  if (days < 25) return t('pantry.freshness.threeWeeks');
  // Everything past a month used to read "~1 month", so a 90-day frozen roast
  // and a 26-day cabbage were indistinguishable.
  if (days <= 45) return t('pantry.freshness.oneMonth');
  if (days <= 75) return t('pantry.freshness.twoMonths');
  if (days <= 135) return t('pantry.freshness.threeMonths');
  if (days <= 270) return t('pantry.freshness.sixMonths');
  return t('pantry.freshness.aYear');
}
